import { useEffect } from 'react';
import './Onboarding.css';
import wagerwizLogo from '../../assets/WagerWiz_OnDark_Vector.svg';

export const OnboardingShell = (props) => {
	const {
		stepIndex,
		totalSteps,
		title,
		subtitle,
		onBack,
		onContinue,
		onSkip,
		canContinue = true,
		continueLabel = 'Continue',
		skipLabel = 'Skip for now',
		showBack = true,
		hideFooter = false,
		fullBleed = false,
		hideChrome = false,
		children,
	} = props;

	useEffect(() => {
		const handleKey = (e) => {
			if (e.key === 'Enter' && canContinue && onContinue && !hideFooter) {
				const tag = document.activeElement?.tagName;
				if (tag !== 'TEXTAREA') {
					onContinue();
				}
			}
		};
		window.addEventListener('keydown', handleKey);
		return () => window.removeEventListener('keydown', handleKey);
	}, [canContinue, onContinue, hideFooter]);

	const progressPct = totalSteps > 0 ? Math.min(100, ((stepIndex + 1) / totalSteps) * 100) : 0;

	if (fullBleed) {
		return (
			<div className="h-full min-h-0 flex flex-col bg-[#0d1018] text-white overflow-hidden">
				{!hideChrome && (
					<div className="flex-shrink-0 px-4 sm:px-8 pt-4 pb-3 max-w-[1200px] mx-auto w-full">
						<div className="flex items-center justify-between mb-3">
							{showBack && onBack ? (
								<div onClick={onBack} className="ob-back">
									<span style={{ fontSize: 18, lineHeight: 1 }}>&#8592;</span> Back
								</div>
							) : (
								<div />
							)}
							<div className="text-xs text-[#8a90a2]">
								Step {stepIndex + 1} of {totalSteps}
							</div>
						</div>
						<div className="ob-progress-track mb-4">
							<div className="ob-progress-fill" style={{ width: `${progressPct}%` }} />
						</div>
					</div>
				)}
				<div className={`flex-1 min-h-0 overflow-y-auto ${hideChrome ? '' : 'ob-fade-in pb-8 sm:pb-10'}`}>
					{children}
				</div>
			</div>
		);
	}

	return (
		<div className="h-full min-h-0 bg-[#0d1018] text-white flex flex-col overflow-hidden">
			<div className="w-full max-w-[640px] mx-auto px-4 sm:px-6 pt-4 sm:pt-6 pb-8 sm:pb-12 flex flex-col flex-1 min-h-0">
				<div className="flex-shrink-0 flex items-center justify-between mb-4">
					{showBack && onBack ? (
						<div onClick={onBack} className="ob-back">
							<span style={{ fontSize: 18, lineHeight: 1 }}>&#8592;</span> Back
						</div>
					) : (
						<img src={wagerwizLogo} alt="WagerWiz" style={{ height: 22 }} />
					)}
					<div className="text-xs text-[#8a90a2]">
						Step {stepIndex + 1} of {totalSteps}
					</div>
				</div>

				<div className="flex-shrink-0 ob-progress-track mb-5">
					<div className="ob-progress-fill" style={{ width: `${progressPct}%` }} />
				</div>

				<div key={stepIndex} className="ob-step-anim ob-card flex-1 min-h-0 flex flex-col overflow-hidden">
					<div className="flex-shrink-0 px-5 sm:px-8 pt-5 sm:pt-7 pb-3">
						{title && <h1 className="text-[26px] sm:text-[30px] font-bold leading-tight">{title}</h1>}
						{subtitle && <p className="mt-2 text-[#a8aebd] text-[14px] sm:text-[15px] leading-relaxed">{subtitle}</p>}
					</div>

					<div className="px-5 sm:px-8 pb-2 flex-1 min-h-0 overflow-y-auto">{children}</div>

					{!hideFooter && (
						<div className="flex-shrink-0 px-5 sm:px-8 pt-4 pb-5 sm:pb-6 border-t border-[#262b3a] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 bg-[#1c2030] rounded-b-[17px]">
							{onSkip ? (
								<div onClick={onSkip} className="ob-ghost text-sm order-2 sm:order-1">
									{skipLabel}
								</div>
							) : (
								<div className="order-2 sm:order-1" />
							)}
							{onContinue && (
								<button
									type="button"
									onClick={onContinue}
									disabled={!canContinue}
									className="ob-cta order-1 sm:order-2 w-full sm:w-auto">
									{continueLabel}
								</button>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
